import React from "react";
import { array, string } from "prop-types";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import "./row2.m.css";

const Row2 = ({ stories, publisherLang }) => {
  const organism1Stories = stories.slice(0, 3);
  const organism2Stories = stories.slice(3, 9);
  const organism3Stories = stories.slice(9, 11);

  return (
    <div styleName="base">
      <div>
        {organism1Stories.length > 0 && <Organism1 stories={organism1Stories} />}
        {organism2Stories.length > 0 && <Organism2 stories={organism2Stories} />}
      </div>
      {organism3Stories.length > 0 && (
        <div styleName="two-stories-wrapper" className={`${publisherLang}-two-stories-wrapper`}>
          {organism3Stories.map((story, index) => (
            <LeftImageRightNews key={index} story={story.story} />
          ))}
        </div>
      )}
    </div>
  );
};

Row2.propTypes = {
  stories: array.isRequired,
  publisherLang: string,
};

export default Row2;
